import {mergeTypeDefs, mergeResolvers} from "graphql-tools";
import {flow as _flow} from "lodash/util"

export function flow(...funcs) {
    return async (a) => {
        for (let f of funcs) {
            a = await f(a);
        }
        return a;
    }
}

export function merge(bundle) {
    return ({typeDefs, resolvers}) => {
        return {
            typeDefs: mergeTypeDefs([typeDefs, bundle.typeDefs]),
            resolvers: mergeResolvers([resolvers, bundle.resolvers])};
    }
}

export function crud() {
    return require(require('path').join(process.cwd(), 'api', 'dist', 'crud'))
}

// done
export {default as guard} from "./transforms/guard"
export {default as unguard} from "./transforms/unguard"
export {default as translate} from "./transforms/translate"
export {default as moveFiles} from "./transforms/moveFiles"
export {default as url} from "./transforms/url"
export {default as validate} from "./transforms/validate"
export {default as thumbs} from "./transforms/thumbs"
